import HTTP from '@/api/HTTP';
const checkout = {
  namespaced: true,
  state: {
    items: [],
    item: {},
    isLoading: false,
    isError: false,
    errorMsg: '',
    successMsg: '',
  },
  getters: {
    checkout: (state) => state.items,
  },
  actions: {
    async sendProcessCheckout({ commit }, payload) {
      commit('setErrorMsg', null);
      commit('setSuccessMsg', null);
      try {
        commit('setIsLoading', true);
        const payment = await HTTP.post('/orders/checkout', payload);
        commit('setItem', payment.data.data);
        commit('setSuccessMsg', 'Thank you for your order');
        commit('setIsLoading', false);
        return payment;
      } catch (error) {
        const response = error.response;
        if (response?.status == 422) {
          commit('setErrorMsg', response?.data?.message);
        }
        if (response?.status == 500) {
          commit('setErrorMsg', response?.data?.data?.message);
        }
        commit('setIsLoading', false);
        return error;
      }
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setItem(state, item) {
      state.item = item;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setIsError(state, isError) {
      state.isError = isError;
    },
    setErrorMsg(state, errorMsg) {
      state.errorMsg = errorMsg;
    },
    setSuccessMsg(state, successMsg) {
      state.successMsg = successMsg;
    },
  },
};

export default checkout;
